import request, { METHODS } from "src/utils/api-base";

const stockApis = {
  getStockLevels: (params: {
    page?: number;
    limit?: number;
    warehouseId?: string;
    productId?: string;
    variantId?: string;
    search?: string;
  }) => {
    return request({
      route: "/app/stock/levels",
      method: METHODS.GET,
      params,
      auth: true,
    });
  },

  adjustStock: (payload: {
    warehouseId: string;
    productId: string;
    variantId?: string;
    direction: "in" | "out";
    quantity: number;
    reason?: string;
  }) => {
    return request({
      route: "/app/stock/adjust",
      method: METHODS.POST,
      payload,
      auth: true,
    });
  },

  // Bulk-set opening stock from parsed spreadsheet rows
  bulkImport: (rows: Array<Record<string, any>>) => {
    return request({
      route: "/app/stock/bulk-import",
      method: METHODS.POST,
      payload: { rows },
      auth: true,
    });
  },

  getStockTransfers: (params: { page?: number; limit?: number }) => {
    return request({
      route: "/app/stock/transfers",
      method: METHODS.GET,
      params,
      auth: true,
    });
  },

  createStockTransfer: (payload: {
    fromWarehouseId: string;
    toWarehouseId: string;
    items: Array<{ productId: string; variantId?: string; quantity: number }>;
  }) => {
    return request({
      route: "/app/stock/transfers",
      method: METHODS.POST,
      payload,
      auth: true,
    });
  },
};

export default stockApis;
